import type { DotTone as Tone } from "@akaike/ui";

/**
 * Qcom's status tones onto the shared Badge's toned outlines.
 *
 * Transitional: `Tone` is Qcom's own vocabulary, and plenty of call sites
 * compute it (`statusTone(run.status)`, `eventTone(kind)`) rather than writing
 * a literal, so the mapping has to live somewhere both they and the literal
 * sites can reach. Once Qcom speaks the shared variant names directly this
 * module is what gets deleted, not the call sites.
 */
export const TONE_VARIANT = {
  ok: "outline-success",
  warn: "outline-warning",
  crit: "outline-destructive",
  info: "outline-info",
  brand: "outline-primary",
  idle: "outline",
} as const satisfies Record<Tone, string>;

export type BadgeTone = (typeof TONE_VARIANT)[Tone];

export function toneVariant(tone: Tone | undefined): BadgeTone {
  return TONE_VARIANT[tone ?? "idle"];
}
